module.exports = __webpack_public_path__ + "static/media/icon-alert.6c2f84c2.svg";